export const pathDividerADMIN = '::'
export const ADMIN_OPTION_SUB_DIV = ';;'

export const getOptionFromPath = (path = '') => {
    if(path === '/admin') return ''
    if(path.includes('/admin/analytics')) return 'Usage Dashboard'
    if(path.includes('/admin/timetracking')) return 'time-tracking'
    if(path.includes('/admin/archive')) return 'recycle-bin'
    if(path.includes('/admin/logs')) return 'logs'
    if(path.includes('/admin/billing')) return 'billing'
	if(path.includes('/admin/important-content')) return 'important-content'
	if(path.includes('/admin/forms')) return 'forms'
	if(path.includes('/admin/navigation')) return 'menu'
    // if(path.includes('/admin/custominputmappings')) return 'input-settings'
    if(path.includes('/admin/custominputmappings')) return 'forms'
    if(path.includes('/admin/topics_and_usertags')) return 'content-managment'
    if(path.includes('/admin/scoreBoardSettings')) return 'scoreboard'
    if(path.includes('/admin/organizationsettings')) return 'org-preferences'
    if(path.includes('/admin/users')) return 'manage-users'
    if(path.includes('/admin/teams')) return 'teams'
    if(path.includes('/admin/templates/editjson/') && !!path.split("/admin/templates/editjson/")?.[1]) return `templates${pathDividerADMIN}editjson${pathDividerADMIN}${path.split("/admin/templates/editjson/")?.[1]}`
    if(path.includes('/admin/templates/edit/') && !!path.split("/admin/templates/edit/")?.[1]) return `templates${pathDividerADMIN}edit${pathDividerADMIN}${path.split("/admin/templates/edit/")?.[1]}`
    if(path.includes('/admin/templates/') && !!path.split("/admin/templates/")?.[1]) return `templates${pathDividerADMIN}${path.split("/admin/templates/")?.[1]}`
    if(path.includes('/admin/templates')) return 'templates'
    if(path.includes('/admin/integrations')) return 'integrations'
    return ''
}

export const isTemplateViewPath = (path = '') => {
    if(!path.includes('templates')) return false
    const parts = path.split(pathDividerADMIN)
    const id = parts?.[parts.length - 1]
    if(!id) return false
    return parts.length === 2
}
export const getTemplatePageId = (path = '') => {
    if(!path.includes('templates')) return ''
    const parts = path.split(pathDividerADMIN)
    const id = parts?.[parts.length - 1]
    if(!id) return ''
    return id
}

export const isTemplateViewEditPath = (path = '') => {
    if(!path.includes('templates')) return false
    const parts = path.split(pathDividerADMIN)
    const id = parts?.[parts.length - 1]
    if(!id) return false
    return parts.length === 3 && parts?.[1] === 'edit'
}

export const isTemplateViewEditJsonPath = (path = '') => {
    if(!path.includes('templates')) return false
    const parts = path.split(pathDividerADMIN)
    const id = parts?.[parts.length - 1]
    if(!id) return false
    return parts.length === 3 && parts?.[1] === 'editjson'
}